const $ = require('jquery');
const gsap = require('../modules/gsap-utils');
const utilities = require('../modules/utilities');


let didGlobalCloseMenu = false;

function maybeSetupGlobalClose() {
    if (didGlobalCloseMenu) {
        return;
    }

    didGlobalCloseMenu = true;

    document.addEventListener('click', event => {
        let parentNode = null;
        //bail if any of the click event parents have the "open-menu" class...
        while ((parentNode = (parentNode || event.target).parentNode) !== null) {
            if (typeof parentNode.classList === 'undefined') {
                break;
            }
            if (parentNode.classList.contains('open-menu')) {
                return;
            }
        }

        //... otherwise close all open menus (user might have clicked on text or blank space for eg)
        for (let $menu of document.querySelectorAll('.open-menu')) {
            $menu.classList.remove('open-menu');
            gsap.anim.closeDropDown($menu.querySelector('ul'));
        }
    });
}

function setupSubMenuOpeners($element) {
    let $candidates = $element.querySelectorAll('li.has-subMenu > ul');

    if ($candidates.length === 0) {
        return;
    }

    for (let $candidate of $candidates) {
        let $opener = document.createElement('button');
        $opener.classList.add('subMenu-opener');
        $opener.innerHTML = '<i class="fas fa-chevron-right"></i>';

        $candidate.parentNode.firstElementChild.appendChild($opener);
    }
}

function setupDropdown($element) {
    if (!$element) {
        throw 'Expected an element, got ' + $element + ' instead...';
    }

    maybeSetupGlobalClose();
    setupSubMenuOpeners($element);

    // noinspection BadExpressionStatementJS
    let _toggleEvent = function (event) {
        if (!utilities.isProbablyMobile()) {
            return;
        }

        let canToggle = false;


        if (event.target.classList.contains('subMenu-opener')) {
            canToggle = true;
        }

        let $el, limit;

        if (!canToggle) {
            limit = 4, $el = event.target;
            while (limit-- > 0) {
                if ($el.classList.contains('subMenu-opener')) {
                    canToggle = true;
                    break;
                }
                $el = $el.parentNode;
            }
        }

        if (!canToggle) {
            return;
        }

        let $listItem;

        limit = 6, $el = event.target;
        while (limit-- > 0) {
            if ($el.tagName === 'LI') {
                $listItem = $el;
                break;
            }
            $el = $el.parentNode;
        }

        //bail if no submenu
        if ($listItem.querySelector('ul').length === 0) {
            return;
        }

        let $childList = $listItem.querySelector('ul');

        event.stopImmediatePropagation();
        event.preventDefault();
        $listItem.classList.toggle('open-menu');

        if ($listItem.classList.contains('open-menu')) {
            //do open anim on $childList
            gsap.anim.openDropDown($childList);
        }
        else {
            //do close anim on $childList
            gsap.anim.closeDropDown($childList);
        }
    };

    //this is for probably mobile devices
    $element.addEventListener('click', _toggleEvent);

    //add focus classes when tabbed through or hovered
    let $aTags = $element.querySelectorAll('a');
}


$.fn.accessibleDropDown = function () {
    let el = $(this);

    /* Make dropdown menus keyboard accessible */

    $("a", el).focus(function () {
        $(this).parents("li").addClass("hover");
    }).blur(function () {
        $(this).parents("li").removeClass("hover");
    });
};

document.addEventListener('DOMContentLoaded', () => {
    for (let $element of document.querySelectorAll('nav.container')) {
        setupDropdown($element);
    }

    let counter = 0;
    window.bobs = [];

    for (let $element of document.querySelectorAll('.has-subMenu')) {
        let $icon = document.createElement('i');
        $icon.setAttribute('class', `menu-down-indicator fas fa-chevron-down counter-check-${counter++}`);
        $element.appendChild($icon);
    }

    $(".navItems").accessibleDropDown();
});

